// eslint-disable-next-line no-restricted-imports
import {
  PositionTipp as IPositionTipp,
  PositionTippDirectionIdEnum as IPositionTippDirectionIdEnum,
} from '@eih-netbroker/api-erste-market';
import { WithRequired } from '../utils';

export type PositionTipp = WithRequired<IPositionTipp, 'openPrice' | 'stopLoss' | 'takeProfit'>;

export const PositionTippDirectionIdEnum = IPositionTippDirectionIdEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PositionTippDirectionIdEnum =
  (typeof PositionTippDirectionIdEnum)[keyof typeof PositionTippDirectionIdEnum];
